<template>
  <v-app-bar app color="white">
    <v-row class="d-flex justify-space-between align-center">
      <v-col class="d-flex align-center">
        <router-link to="/">
          <img src="@/assets/logo.png" height="24px">
        </router-link>
        <span v-if="showDevDbChip" class="ml-5">
          <v-chip :dark="devDbChip.dark" :class="devDbChip.type">
            {{ devDbChip.text }} Data
          </v-chip>
        </span>
      </v-col>
      <v-col>
        <Search class="mt-5 hidden-md-and-down" />
      </v-col>
      <v-col class="d-flex justify-end">
        <router-link :to="{ name: 'Employee Directory' }">
          <v-btn rounded text :color="uploadColor">
            <v-icon left>mdi-account-details</v-icon>
            <span class="hidden-md-and-down"
            >Directory</span>
          </v-btn>
        </router-link>

        <router-link :to="{ name: 'Dashboard' }">
          <v-btn rounded text :color="dashboardColor">
            <v-icon left>mdi-chart-pie</v-icon>
            <span class="hidden-md-and-down"
            >Dashboard</span>
          </v-btn>
        </router-link>
        
        <router-link  v-if="userHasClearances" :to="{ name: 'Tests' }">
          <v-btn rounded text :color="testsColor">
            <v-icon left>mdi-shield-check</v-icon>
            <span class="hidden-md-and-down"
            >Clearances</span>
          </v-btn>
        </router-link>
        
        <router-link :to="{ name: 'Home' }">
          <v-btn rounded text :color="curriculumColor">
            <v-icon left>mdi-book-open-page-variant</v-icon>
            <span class="hidden-md-and-down"
            >Curriculums</span>
          </v-btn>
        </router-link>
        
        <router-link v-if="user" :to="{ name: 'Logout' }">
          <v-btn rounded text :color="loginOutColor">
            <v-icon left>mdi-logout</v-icon>
            <span class="hidden-md-and-down"
            >Logout</span>
          </v-btn>
        </router-link>
        <router-link v-else :to="{ name: 'Login' }">
          <v-btn rounded text :color="loginOutColor">
            <v-icon left>mdi-login</v-icon>
            <span class="hidden-md-and-down"
            >Login</span>
          </v-btn>
        </router-link>
        
      </v-col>
    </v-row>    

  </v-app-bar>
</template>

<script>
  import { environment, isUsingProdData } from '@/config'
  import Search from '@/components/Search'
  import User from '@/mixins/User'
  
  export default {
    name: 'Navigation',
    mixins: [ User ], 
    components: {
      Search
    },
    computed: {
      curriculumColor () {
        return this.$route.name !== 'Dashboard' && 
               this.$route.name &&
               !this.$route.name.includes('Test') &&
               !this.$route.name.includes('Log') &&
               !this.$route.name.includes('Employee') ? 'primary' : null
      },
      dashboardColor () { 
        return this.$route.name === 'Dashboard' ? 'primary' : null
      },
      uploadColor () {
        return this.$route.name && 
               this.$route.name.includes('Employee') ? 'primary' : null
      },
      testsColor () {
        return this.$route.name &&
               this.$route.name.includes('Test') ? 'primary' : null
      },
      loginOutColor () {
        return this.$route.name &&
               this.$route.name.includes('Log') ? 'primary' : null
      },
      showDevDbChip () {
        return !environment.isProd
      },
      devDbChip () {
        if (isUsingProdData) {
          return {
            type: 'error',
            text: 'Production'
          }
        }
        return {
          type: 'purple',
          dark: true,
          text: 'Development'
        }
      }
    }
  }
</script>

<style>
  a {
    text-decoration: none;
  }
</style>
